<template>
	<div id="app">
		<!-- <component :is="layout">
			<router-view :key="$route.fullPath" />
		</component> -->
		<main-layout>
			<router-view :key="$route.fullPath" />
		</main-layout>
		<!-- <main-layout :typeLayout="typeLayout" :footerStyle="footerStyle">
			<router-view :key="$route.fullPath" />
		</main-layout> -->
	</div>
</template>

<script>
import MainLayout from './layouts/MainLayout.vue'
// const DEFAULT_LAYOUT = MainLayout
export default {
	name: 'App',
	components: {
		'main-layout': MainLayout,
	},
	data () {
		return {
			// layout: DEFAULT_LAYOUT,
		}
	},
	/*watch: {
		$route: {
			immediate: true,
			async handler(route) {
				try {
					// let component
					// let routeLayout = route.meta.layout[0].toUpperCase() + route.meta.layout.substring(1)

					// if (route.meta.layout === 'public')
					// 	component = await import(`@/layouts/${projName}/${routeLayout}Layout.vue`)
					// else
					// 	component = await import(`@/layouts/default/${routeLayout}Layout.vue`)

					this.layout = DEFAULT_LAYOUT //component?.default || DEFAULT_LAYOUT
				} 
				catch (e) {
					this.layout = DEFAULT_LAYOUT
				}
			}
		}
	},*/
}
</script>